const NAMESPACE = "WALLET_CONNECT";

// Wallet connect
export const WALLET_CONNECT_INITIALIZE_REQ = `${NAMESPACE}/INITIALIZE_REQ`;
export const WALLET_CONNECT_INITIALIZE_OK = `${NAMESPACE}/INITIALIZE_OK`;
export const WALLET_CONNECT_UPDATE_SESSION = `${NAMESPACE}/UPDATE_SESSION`;
export const WALLET_CONNECT_CONNECTED = `${NAMESPACE}/CONNECTED`;
export const WALLET_CONNECT_RESET = `${NAMESPACE}/RESET`;
